export default __webpack_public_path__ + "static/media/Gabby 9781408347232.142d29ef.jpg";